import type { SignalRecommenderFileDto, SignalRecommenderFilesResponseDto } from "../types/dto";
import type { SignalRecommenderFile, SignalRecommenderHistory } from "../types/model";

const mapSignalRecommenderFile = (dto: SignalRecommenderFileDto): SignalRecommenderFile => ({
    id: dto.id,
    fileName: dto.fileName,
    created: dto.created,
    companiesCount: dto.companiesCount,
    signalsFoundCount: dto.foundSignalsCount,
    status: dto.status,
    isDownloaded: dto.isDownloaded,
});

export const mapSignalRecommenderHistory = (dto: SignalRecommenderFilesResponseDto): SignalRecommenderHistory => ({
    files: dto.enrichments.map(mapSignalRecommenderFile),
    nextUploadAllowedAt: dto.nextUploadAllowedAt,
});
